import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, forkJoin, map, of } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';
import { ComparatorRepository } from 'src-ironside/repositories/comparator.repository';
// import { ComparatorRepository } from 'src-ironside/repositories/comparator.repository';
import { Product } from 'src-ironside/repositories/product.repository';
import { ResourceRepository } from 'src-ironside/repositories/resource.repository';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

@Component({
    selector: 'app-product-comparator-ironside',
    templateUrl: './product-comparator-ironside.component.html',
    styleUrls: ['./product-comparator-ironside.component.css'],
    providers: [
        DynamicDocumentService,
        CommonService,
        UserService,
        ComparatorRepository,
        ResourceRepository,
    ],
})
export class ProductComparatorIronsideComponent {
    products?: Product[];
    listIdProduct: any[] = [];
    listProducts: any[] = [];
    listImageSustainableDevelopments = [
        {
            id: 1,
            field: 'europeanEcolabel',
            label: 'Ecolabel Européen',
            urlImage: 'src-adisco/assets/images/sustainable-developments/ECOLABEL_EUROPEEN.png',
        },
        {
            id: 2,
            field: 'cradleToCradle',
            label: 'Cradle to Cradle (C2C)',
            urlImage: 'src-adisco/assets/images/sustainable-developments/cradle-to-cradle.png',
        },
        {
            id: 3,
            field: 'nordicSwan',
            label: 'Nordic Swan',
            urlImage: 'src-adisco/assets/images/sustainable-developments/swan_nordic_label.png',
        },
        {
            id: 4,
            field: 'austrianEcolabel',
            label: 'Ecolabel Autrichien',
            urlImage: 'src-adisco/assets/images/sustainable-developments/ecolabel_autrichien.png',
        },
        {
            id: 5,
            field: 'ecocert',
            label: 'Ecocert',
            urlImage: 'src-adisco/assets/images/sustainable-developments/Logo_Ecocert_Colour.png',
        },

        {
            id: 6,
            field: 'emas',
            label: 'EMAS',
            urlImage: 'src-adisco/assets/images/sustainable-developments/EMAS.png',
        },
        {
            id: 7,
            field: 'fsc',
            label: 'FSC',
            urlImage: 'src-adisco/assets/images/sustainable-developments/FSC.png',
        },
        {
            id: 8,
            field: 'reach',
            label: 'REACH',
            urlImage: 'src-adisco/assets/images/sustainable-developments/REACHCompliant.png',
        },
        {
            id: 9,
            field: 'foodContact',
            label: 'Contact alimentaire',
            urlImage:
                'src-adisco/assets/images/sustainable-developments/1200px-EU_food_contact_material_symbol.png',
        },
        {
            id: 10,
            field: 'clpSafetyPicto',
            label: 'CLP (pictos de sécurité)',
            urlImage: 'src-adisco/assets/images/sustainable-developments/sans-picto-danger.svg',
            parseToBooleanValueTrue: 'SANS',
        },
        {
            id: 11,
            field: 'biocide',
            label: 'BIOCIDE',
            urlImage: 'src-adisco/assets/images/sustainable-developments/Produit_Biocide.png',
        },
    ];

    listProductCompare: any[] = JSON.parse(localStorage.getItem('compare') as any);

    constructor(
        private _commonService: CommonService,
        private comparatorRepository: ComparatorRepository,
        private dynamicDocumentService: DynamicDocumentService,
        public userService: UserService,
        private cdr: ChangeDetectorRef,
        private resourceRepository: ResourceRepository,
        private router: Router
    ) {
        if (this.listProductCompare) {
            this.listProducts = this.listProductCompare;
            this.listIdProduct = this.listProducts.map((ele) => {
                return ele?.id;
            });
        }
        this._commonService.getClickCompare().subscribe((data) => {
            if (this.listIdProduct.length > 0 && this.listIdProduct) {
                this.getListProductComparators(this.listIdProduct);
            }
        });
        this._commonService.getClickCompareComplete().subscribe((data) => {
            window.location.reload();
        });
    }

    ngOnInit(): void {
        this.comparatorRepository.getMyComparators().subscribe((res) => {
            const data: string[] = res.map((el) => el.id!);
            this.getListProductComparators(data);
        });
    }

    getListProductComparators(ids: any[]): void {
        this._commonService.getListComparer(ids).subscribe({
            next: (res) => {
                this.listProducts = res?.response || [];

                const supplierRequests = this.listProducts?.map((product) =>
                    product?.nameSupplier && product?.nameSupplier?.length > 0
                        ? this.getNameSupplier(product?.nameSupplier?.[0]?.value)
                        : of('')
                );

                const imageRequests = this.listProducts?.map((product) =>
                    product?.linkToRessources && product?.linkToRessources?.length > 0
                        ? this.getListImage(product?.linkToRessources)
                        : of('src-adisco/assets/images/image-default.jpg')
                );

                const tariffRequests = this.listProducts.map((product) => {
                    if (product?.linkToTariff && product?.linkToTariff?.length > 0) {
                        const listIdTariff: any[] = product?.linkToTariff?.map(
                            (item: any) => item?.documentId
                        );
                        return this.getTariff(listIdTariff);
                    } else {
                        return of('');
                    }
                });

                forkJoin([...supplierRequests, ...imageRequests, ...tariffRequests]).subscribe(
                    (results) => {
                        const supplierResults = results.slice(0, supplierRequests.length);
                        const imageResults = results?.slice(
                            supplierRequests?.length,
                            supplierRequests?.length + imageRequests?.length
                        );
                        const tariffResults = results?.slice(
                            supplierRequests?.length + imageResults?.length
                        );

                        this.listProducts = this.listProducts?.map((product, index) => ({
                            ...product,
                            companyName: supplierResults?.[index] || '',
                            urlImage:
                                imageResults?.[index] ||
                                'src-ironside/assets/images/image-default.jpg',
                            price: tariffResults?.[index]?.price || 0,
                        }));
                    }
                );
            },
            error: (_error) => {
                console.error('Error fetching product comparators:', _error);
            },
            complete: () => {},
        });
    }

    getTariff(ids: any[]): Observable<any> {
        return this._commonService.getDataTariff(ids).pipe(
            map((res) => {
                const latestItem = res.response.reduce((prev: any, current: any) => {
                    return prev.price > current.price ? prev : current;
                });
                return { price: latestItem?.price };
            })
        );
    }

    getListImage(res: Array<{ documentId: string }>): Observable<string> {
        const ids = res.map((el) => el?.documentId);

        return this.resourceRepository.findByIds(ids).pipe(
            map((res: any) => {
                const dataListImage = res;
                if (!Array.isArray(dataListImage)) {
                    return 'src-ironside/assets/images/image-default.jpg';
                }

                const firstMatchingItem = dataListImage.find((item: any) => {
                    return item?.typeOfResource === 'PHOTO' && item?.files?.length > 0;
                });

                return (
                    firstMatchingItem?.files[0]?.url ||
                    'src-ironside/assets/images/image-default.jpg'
                );
            })
        );
    }

    getNameSupplier(code: any): Observable<any> {
        return this.dynamicDocumentService
            .find({
                collectionName: 'dynamic_legal_entity',
                filters: [
                    {
                        fieldName: 'code',
                        conditions: [
                            {
                                type: 'EQUALS',
                                value: code,
                            },
                        ],
                    },
                ],
                page: 1,
                pageSize: 150,
            })
            .pipe(
                map((res: any) => {
                    if (res.content[0]?.companyName != null) {
                        return res.content[0].companyName;
                    }
                    return '';
                })
            );
    }

    displayImgSusDev(imgSusDev: any, itemData: any) {
        let expectedValue = typeof itemData === 'boolean' ? itemData : itemData?.value ?? undefined;

        if (
            imgSusDev?.parseToBooleanValueTrue !== null &&
            imgSusDev?.parseToBooleanValueTrue !== undefined
        ) {
            return expectedValue === imgSusDev.parseToBooleanValueTrue;
        }
        return expectedValue ?? false;
    }

    navigateToProduct(productId: string): void {
        this.router.navigate(['/product/detail', productId]);
    }
}
